import { EmptyState as GenericEmptyState } from '@/components/ui/EmptyState';
import { GitBranch } from 'lucide-react';

/**
 * Empty state for legislation comparison when no differences are found.
 * Uses the generic EmptyState component with legislation-specific styling.
 */
const EmptyState = () => {
  return (
    <div className='border rounded-md bg-surface-subtle border-line-default'>
      <GenericEmptyState
        icon={GitBranch}
        title='No Differences Found'
        message='The selected versions appear to be identical, or there may be an issue with the comparison service.'
        size='lg'
      />
    </div>
  );
};

export default EmptyState;
